import { Input, type InputProps } from '@/components/common/Input';
import { validateEmail } from '../validation';

interface EmailInputProps extends Omit<InputProps, 'type' | 'error'> {
  value: string;
  onChange: (value: string) => void;
  /**
   * Caller-provided error (e.g. server-side validation). Surfaced verbatim.
   * Live "looks invalid" feedback is computed locally on top of this when
   * the value is non-empty and fails the format regex.
   */
  error?: string;
}

/**
 * Email input with live "looks invalid" feedback. Empty value renders no
 * error so the operator isn't yelled at before they've typed anything; once
 * they start typing, the regex from validation.ts is the source of truth
 * the form's blocking validation also uses, so the live and submit-time
 * feedback never disagree.
 */
export function EmailInput({ value, onChange, error, ...rest }: EmailInputProps) {
  const liveError = value.length > 0 && !validateEmail(value) ? 'Invalid email address' : undefined;
  return (
    <Input type="email" value={value} onChange={onChange} error={error ?? liveError} {...rest} />
  );
}
